import {initializeOptimizely} from './InitializeOptimizely';

let optimizelyUser = null;

function getDecisions(eventName) {
  const decision = optimizelyUser.decide(eventName);
  const variationKey = decision.variationKey;
  console.log(`Variation Key: ${variationKey}`);
  return {
    variationKey
  };
}

export async function isFeatureEnabled(eventName, appConfig, customerData) {
  if (customerData.isDealerHostApplication?.value !== true) {
    if (optimizelyUser === null) {
      await initializeOptimizely(appConfig, customerData).then((res) => {
        optimizelyUser = res;
      });
      return getDecisions(eventName);
    }
    return getDecisions(eventName);
  }
  return {variationKey: "not_in_experiment"};
}

export function trackEvents(eventName, customerData) {
  if (!customerData.isDealerHostApplication.value && customerData.countryCode.value === 'USA' && optimizelyUser !== null) {
      optimizelyUser.trackEvent(eventName);
    }
}
